import React from 'react';
import ReportingFinancesDepositsPage from '../components/ReportingFinancesDepositsPage';

const ReportingFinancesDepositsApp = (props) => (
  <ReportingFinancesDepositsPage {...props} />
);

export default ReportingFinancesDepositsApp;
